import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { StockService } from '../../../../Services/Stock/stock.service';
import { OrderCreationService } from '../../../../Services/order-creation.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';

@Component({
  selector: 'app-issue-rawmaterial',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './issue-rawmaterial.component.html',
})
export class IssueRawmaterialComponent implements OnInit {

  issueRawForm!: FormGroup;

  allStocks: any[] = [];
  filteredStocks: any[] = [];
  kalakarSuppliers: any[] = [];
  selectedFirm: any;
  issuedList: any[] = [];
  selectedStock: any = null;

  constructor(
    private fb: FormBuilder,
    private stockService: StockService,
    private orderCreationService: OrderCreationService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService
  ) {}

  ngOnInit() {
  this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
    this.selectedFirm = firm?.id;

    this.initForm();
    this.loadStocks();
    this.loadKalakars();
    this.listenTypeChange();
    this.listenAssigneeChange();
    this.loadIssuedRawMaterials(); // ✅ ADD THIS
  });
}


  
  
  /* ---------------- FORM ---------------- */

  initForm() {
    this.issueRawForm = this.fb.group({
      ordc_request_type: ['', Validators.required],   // raw_metal / raw_stone

      ordc_product_code: ['', Validators.required],
      ordc_product_name: [{ value: '', disabled: true }],
      ordc_unit: [{ value: '', disabled: true }],
      ordc_available_quantity: [{ value: 0, disabled: true }],

      ordc_quantity: ['', [Validators.required, Validators.min(1)]],

      ordc_assined_to: ['', Validators.required],
      ordc_assined_to_name: [''],   // ✅ REQUIRED (FIX)

      ordc_description: [''],
      ordc_firm_id: this.selectedFirm,
    });
  }

  /* ---------------- STOCKS ---------------- */

  loadStocks() {
    this.stockService.getStockEntries().subscribe((res: any) => {
      this.allStocks = res.data || [];
      console.log('ALL STOCKS', this.allStocks);
    });
  }

  listenTypeChange() {
  this.issueRawForm.get('ordc_request_type')?.valueChanges.subscribe(type => {

    this.selectedStock = null; // ✅ reset card

    this.filteredStocks = this.allStocks.filter(
      s => s.st_product_code_type === type
    );

    this.issueRawForm.patchValue({
      ordc_product_code: '',
      ordc_product_name: '',
      ordc_unit: '',
      ordc_available_quantity: 0
    });
  });
}
   getAssigneeName(userId: any): string {
  const id = Number(userId); // 🔥 normalize

  const user = this.kalakarSuppliers.find(
    u => Number(u.id) === id
  );

  return user ? user.name : '-';
}


  onProductCodeSelect(event: any) {
  const code = event.target.value;

  const selected = this.filteredStocks.find(
    s => s.st_item_code === code
  );

  if (!selected) {
    this.selectedStock = null;
    return;
  }

  // ✅ store full object for display
  this.selectedStock = selected;

  // ✅ patch form fields
  this.issueRawForm.patchValue({
    ordc_product_name: selected.st_item_name,
    ordc_available_quantity: Number(selected.st_quantity),
    ordc_unit: selected.st_unit || 'GM'
  });
}


  /* ---------------- KALAKAR ---------------- */
loadKalakars() {
  console.log('loadKalakars() CALLED');

  this.orderCreationService.getKalakarSuppliers().subscribe({
    next: (res: any) => {
      console.log('RAW KALAKAR RESPONSE =>', res);
      this.kalakarSuppliers = res.data ?? [];
      console.log('KALAKAR ARRAY =>', this.kalakarSuppliers);
    },
    error: (err) => {
      console.error('KALAKAR API ERROR', err);
    }
  });
}


  listenAssigneeChange() {
    this.issueRawForm.get('ordc_assined_to')?.valueChanges.subscribe(userId => {
      const user = this.kalakarSuppliers.find(u => u.id == userId);
      if (!user) return;

      const fullName = `${user.name ?? ''} ${user.user_last_name ?? ''}`.trim();

      this.issueRawForm.patchValue({
        ordc_assined_to_name: fullName
      });

      console.log('Assigned To:', fullName);
    });
  }


  loadIssuedRawMaterials() {
  this.orderCreationService
    .getIssuedRawMaterials(this.selectedFirm)
    .subscribe((res: any) => {
      this.issuedList = res.data || [];
      console.log('ISSUED RAW MATERIALS =>', this.issuedList);
    });
}
  /* ---------------- SUBMIT ---------------- */

   issueMaterial() {
  /* ---------------- BASIC VALIDATION ---------------- */
  const available =
    +this.issueRawForm.get('ordc_available_quantity')?.value || 0;
  const issueQty =
    +this.issueRawForm.get('ordc_quantity')?.value || 0;

  if (available <= 0) {
    this.notificationService.showError(
      'No stock available to issue',
      'Invalid Operation'
    );
    return;
  }

  if (issueQty <= 0 || issueQty > available) {
    this.notificationService.showError(
      `Issue quantity must be between 1 and ${available}`,
      'Invalid Quantity'
    );
    return;
  }

  if (this.issueRawForm.invalid) {
    this.issueRawForm.markAllAsTouched();
    return;
  }

  const form = this.issueRawForm.getRawValue();

  /* ---------------- RAW ITEM ---------------- */
  const selectedItem = this.filteredStocks.find(
    item => item.st_item_code === form.ordc_product_code
  );

  if (!selectedItem) {
    this.notificationService.showError(
      'Selected stock item not found',
      'Error'
    );
    return;
  }

  /* ---------------- METAL / STONE DETAILS ---------------- */
  let metalDetails: any[] = [];
  let stoneDetails: any[] = [];

  if (selectedItem.st_product_code_type === 'raw_metal') {
    metalDetails.push({
      code: selectedItem.st_item_code,
      quantity: issueQty,
      per_piece_weight: Number(selectedItem.st_subunit) || 0,
      calculated_product_qty: issueQty,
      total_silver:
        issueQty * (Number(selectedItem.st_subunit) || 0)
    });
  }

  if (selectedItem.st_product_code_type === 'raw_stone') {
    stoneDetails.push({
      code: selectedItem.st_item_code,
      quantity: issueQty,
      calculated_product_qty: issueQty,
      total_stone: issueQty
    });
  }

  /* ---------------- PRICES ---------------- */
  const metalPrice =
    selectedItem.st_product_code_type === 'raw_metal'
      ? issueQty * (Number(selectedItem.st_unit_price) || 0)
      : 0;

  const stonePrice =
    selectedItem.st_product_code_type === 'raw_stone'
      ? issueQty * (Number(selectedItem.st_sub_unit_price) || 0)
      : 0;

  const finalValue = metalPrice + stonePrice;

  /* ---------------- FINAL PAYLOAD ---------------- */
  const payload = {
    ordc_firm_id: this.selectedFirm,

    ordc_product_code: selectedItem.st_item_code,
    ordc_product_name: selectedItem.st_item_name,

    ordc_quantity: issueQty,
    ordc_available_quantity: issueQty,

    ordc_metal_price: metalPrice,
    ordc_stone_price: stonePrice,
    ordc_final_value: finalValue,

    ordc_metal_details: metalDetails,
    ordc_stone_details: stoneDetails,

    ordc_assined_to: form.ordc_assined_to,
    ordc_description: form.ordc_description || '',

    ordc_status: 'issued',
    ordc_request_status: 'raw_material_issue'
  };

  console.log('ISSUE RAW MATERIAL PAYLOAD →', payload);

  /* ---------------- API CALL ---------------- */
  this.orderCreationService.createOrder(payload).subscribe({
    next: () => {
      this.notificationService.showSuccess(
        'Raw material issued successfully!',
        'Success'
      );

      this.clearForm();

      // ✅ IMPORTANT: refresh UI state
      this.loadIssuedRawMaterials(); // issued list
      this.loadStocks();             // refresh available stock
    },
    error: (err) => {
      console.error('❌ Issue Raw Material Error:', err);
      this.notificationService.showError(
        err?.error?.message || 'Failed to issue raw material',
        'Error'
      );
    }
  });
}


  clearForm() {
    this.issueRawForm.reset();
  }

  handOver(orderId: number) {
  this.orderCreationService.handOverOrder(orderId).subscribe({
    next: () => {
      this.notificationService.showSuccess(
        'Raw material handed over successfully',
        'Success'
      );
      this.loadIssuedRawMaterials();
       this.loadStocks(); 
        this.clearForm(); // refresh table
    },
    error: (err) => {
      this.notificationService.showError(
        err?.error?.message || 'Hand over failed',
        'Error'
      );
    }
  });
}

}
